<!--  -->
<template>
  <div>
    <!-- 注册页头部  -->
    <div :class="['reg-header', type === 'forget' ? 'bottom-line' : '']">
      <div class="gtn-tip">
        <a class="gtn-logo" href="/"></a>
        <span class="gtn-vertical">|</span>
        <span>
          {{
            type === "login" ? "登录" : type === "forget" ? "忘记密码" : "注册"
          }}
        </span>
      </div>
      <div class="help" v-if="type !== 'forget'">
        <a @click="goDoc(type)">文档中心</a>
        <a
          href="/openplat-front/login"
          v-if="type === 'register'"
          @click.native="handleTrack('PC_注册_登录')"
        >登录</a>
        <a href="/openplat-front/register" v-else @click.native="handleTrack('PC_登录_注册')">注册</a>
      </div>
    </div>
    <!-- 注册页头部  end-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import trackMixin from "@/components/mixins/track.js";
export default {
  data() {
    return {};
  },
  props: ["type"],
  mixins: [trackMixin],
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    goDoc(type) {
      type == "login"
        ? this.handleTrack("PC_登录_文档中心")
        : this.handleTrack("PC_注册_文档中心");
      window.open("/openplat-doc/gtnDoc", "_blank");
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log(this.user);
  }
};
</script>
<style lang="scss" scoped>
.reg-header {
  width: 100%;
  height: 60px;
  background: #fff;
  position: fixed;
  top: 0px;
  z-index: 5;
  .gtn-tip {
    .gtn-logo {
      float: left;
      width: 136px;
      height: 40px;
      margin: 10px 0 0 140px;
      background: url("~@/assets/index/logo.svg") center center no-repeat;
      background-size: 100%;
    }
    span {
      float: left;
      height: 14px;
      line-height: 14px;
      margin: 23px 0;
      font-size: 14px;
      color: #333333;
    }
    .gtn-vertical {
      margin: 23px 16px;
      font-size: 1px;
      color: #d9d9d9;
    }
  }
  .help {
    float: right;
    margin-right: 140px;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 110px;
    justify-content: space-between;
    a {
      opacity: 0.8;
      font-size: 12px;
      color: #000000;
    }
  }
}
.bottom-line {
  border-bottom: 1px solid #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/headerBar.vue